import { PaperSize } from "building-types/annotation/annotationTypesEnum";
import type { DocEntityHandle } from "building-types/handles/docEntityHandleTypes";
import type { TextRotationBasis } from "building-types/views/Primitive2DOutput";
import type { SheetInches } from "common/types/nominalNumbersTypes";
import type { AABB2 } from "geom/aabb2Types";
import { TAG_FONT_SIZE, TAG_FONT_SIZE_FOR_11_X_17 } from "pdf/planFonts";

/** TODO: remove this interface in favor of directly utilizing PlanTextGeometry */
export interface Label {
  readonly handle?: DocEntityHandle;
  readonly text: string;
  readonly textRotationRads?: number;
  readonly textRotationBasis?: TextRotationBasis; // we only need this until the above TODO is taken care of
  readonly fontSize: SheetInches;
  readonly centerX?: number;
  readonly centerY?: number;
  readonly relaxationRangeAABB?: AABB2;
  readonly relaxationNormalX?: number;
  readonly relaxationNormalY?: number;
}

export function labelNew({
  text,
  fontSize,
  centerX,
  centerY,
  textRotationRads = 0,
  textRotationBasis,
  relaxationRangeAABB,
  relaxationNormalX,
  relaxationNormalY,
  handle,
}: Label): Label {
  return {
    text,
    fontSize,
    centerX,
    centerY,
    textRotationRads,
    textRotationBasis,
    relaxationRangeAABB,
    relaxationNormalX,
    relaxationNormalY,
    handle,
  };
}

export function tagFontSize(paperSize: PaperSize) {
  const baseFontSize = paperSize === PaperSize.SHEET_11X17 ? TAG_FONT_SIZE_FOR_11_X_17 : TAG_FONT_SIZE;
  return baseFontSize;
}
